





















































import { Vue } from 'division-marker';
import { Component, Prop, Watch, SaitenState, ConstsState, DmShareds, Modal } from 'saiten-base';


var Loading = require('vue-loading-overlay')
import QrDialog from './QrDialog.vue';

@Component({components: {Loading, QrDialog, Modal}, mixins:[]})
export default class PhotoTaken extends Vue {
  @Prop() sheet_id! : string
  @Prop() sheet_activity_id! : string
  sheet: any = null;
  sheet_pages: any[] | null = null;
  terms: any[] | null = null;
  current_page : any= {};
  is_loading = false;
  alert_message: string | null = null;
  expected_qr: string | null = null
  qr_page: number | null = null;
  

  get my_modal_ref(){return this.$refs.myModalRef as Modal}
  get alert_modal(){return this.$refs.alert_modal as Modal}
  get take_files() {return this.$refs.take_files as HTMLInputElement[]}
  // 親が見えるかどうか
  get pages_shown(){return this.sheet_pages != null && this.qr_page == null}
  async mounted() {
    // ページロード
    try{
      const res = await DmShareds.Http.get(`./api/study/sheets/${this.sheet_id}`)
        this.sheet = res.data
        let sheet_pages: any[] = [];
        this.sheet.sheet_pages.forEach((page: any)=>{
          page.qr_loaded = page.page == 0;
          page.taken = false;
          sheet_pages.push(page)
        })
        this.sheet_pages = sheet_pages
      }catch(err){
        this.show_alert("帳票情報が不正です。").then(()=>{
          history.back()
        })
      }
  }
  
  // QR 関連==========================
  // QR撮影可能かどうか
  allow_take_qr(sheet_page: any){
    if(sheet_page.qr_loaded) return false
    else if(sheet_page.page == 0) return false;
    else if(this.sheet_pages![sheet_page.page - 1].taken) return true
    else return false;
  }
  // QRを読む
  read_qr(sheet_page: any){
    if(!this.allow_take_qr(sheet_page)) return
    this.expected_qr = sheet_page.qr
    this.qr_page = sheet_page.page
  }
  // QR成功
  async qr_success(){
    const page = this.qr_page!;
    this.sheet_pages![this.qr_page!].qr_loaded = true        
    this.expected_qr = null
    this.qr_page = null
    await new Promise(resolve => setTimeout(resolve, 100));
    this.show_alert(`二次元バーコードの読み取りに成功しました。${page + 1}ページの答案を撮影してください。`)
    // this.take_files[page].click();
  }
  qr_hidden(){
    this.$emit('hide')
    this.expected_qr = null
    this.qr_page = null
  }
  // 画像選択し,送信を行う
  async select_file(e: Event, page: any) {
    console.log("送信開始")
    e.preventDefault();
    let files = (e.target as HTMLInputElement).files!;
    (e.target as HTMLInputElement).files = null
    if(files.length == 0) return
    let file = files[0]

    const image_data: ImageData = await DmShareds.ImageConverter.file2imageData(file);
    let gaso_man = Math.round(image_data.width * image_data.height / 1000);
    const min = 600
    if(gaso_man < min * 1.2){
      this.show_alert(`撮影された写真は${gaso_man}万画素です。${min}万画素以上で撮影を行ってください。`)
      return;
    }
    this.send_photo(file, page);
  }

  // 写真を送付する
  async send_photo(file:File, page: any){
    var fd = new FormData();
    fd.append('file', file);
    fd.append('direction', this.sheet.direction);
    this.is_loading = true;

    try{
      const response = await DmShareds.Http.post(`./api/study/predictiong/${this.sheet_id}-${page.page}`, fd)
      // 読み取り成功
      console.log("データ変換成功")
      if(response.data.result == "ok"){
        page.image_id = response.data.image_id
        const image64 = response.data.image
        page.image_url = `data:image/png;base64,${image64}`
        page.rotete = 0
        this.is_loading = false
        this.show_page_dialog(page)
      }else{
        this.show_alert(response.data.message)
        this.is_loading = false
      }
    }catch(err){
      this.is_loading = false
      let data = err.response.data
      if (data) {
        let message = data.message != null ? data.message : "アップロードエラーが発生しました。"
        this.show_alert(message)
      } else {
        this.show_alert("画像のアップロードに失敗しました。")
      }
    }
  }
  // 送信可能かどうか
  sendable() {
    return this.sheet != null && this.sheet_pages!.some(page => page.taken)
  }
  
  rotate(sheet_page: any){
    console.log(sheet_page)
    const img = new Image();
    img.onload = ()=>{
      let canvas = document.createElement('canvas');
      canvas.height = img.height;
      canvas.width = img.width;
      const ctx = canvas.getContext("2d")!;
      ctx.translate(img.width/2, img.height/2);
      ctx.rotate(180 * Math.PI/180);
      // ctx.drawImage(img, 0, 0);
      ctx.drawImage(img, -(img.width/2), -(img.height/2));
      const new_image_url = canvas.toDataURL("image/jpeg")
      sheet_page.image_url = ''
      sheet_page.image_url = canvas.toDataURL("image/jpeg")
      this.$forceUpdate();
      DmShareds.Http.post(`./api/study/predicted_image/${sheet_page.image_id}`, {image64:new_image_url})
    }
    const image_url = sheet_page.image_url as string;
    img.src = image_url;
  }

  // ダイアログにプレビュー表示
  show_page_dialog(page: number) {
    this.current_page = page
    this.my_modal_ref.show()
  }
  photo_taken(page_info: any) {
    this.sheet_pages![page_info.page].taken = true
    // this.current_page = null 
    this.my_modal_ref.hide()
    this.$forceUpdate();
  }
  reset_page() {
    this.current_page.taken = false
    this.my_modal_ref.hide()
    this.$forceUpdate();
  }
  //データ送信
  send_data() {
    if (!this.sendable()) return
    this.is_loading = true
    let image_ids = this.sheet_pages!.filter(page => page.taken).map(page=>page.image_id)
    DmShareds.Http.post(`./api/study/upload_answer_images/${this.sheet_id}-${this.sheet_activity_id}`, {image_ids: image_ids})
      .then((response: any) => {
        this.is_loading = false
        this.show_alert("採点登録が完了しました。").then(()=>{
          window.location.href = "#/study/top"
        })
      }, (error: any) => {
        this.is_loading = false
        this.show_alert("送信が失敗しました").then(()=>{this.is_loading = false})
      })
  }
  // アラートを表示する
  show_alert(message: string){
    return new Promise((resolve, reject)=>{
      this.alert_message = message
      this.alert_modal.show()
      this.alert_resolve = resolve
    });
  }
  alert_resolve:(()=>void) | null = null;
  // アラートが閉じられた場合
  hidden_alert(){
    if(this.alert_resolve != null) this.alert_resolve()
    this.alert_resolve = null;
  }
  // enter の初めにインデックス×100でディレイを付ける
  beforeEnter(el: any) {
    el.style.transitionDelay = 50 * el.dataset.index + 'ms'
  }
  // enter が終わるか中止されたらディレイを消す
  afterEnter(el: any) {
    el.style.transitionDelay = ''
  }
}
